"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSubformResults = void 0;
const calculators_1 = require("./calculators");
const calculateSubformResults = (type, calculationMethod, inputs, declarationYear) => {
    const calculate = (0, calculators_1.getCalculator)(type, calculationMethod);
    if (!calculate) {
        throw new Error(`Couldn't find calculator for type "${type}" and calculationMethod "${calculationMethod}"`);
    }
    return calculate(inputs, declarationYear);
};
exports.calculateSubformResults = calculateSubformResults;
//# sourceMappingURL=calculate.js.map